<template>
    <div class="btn-run-processing">
        <div class="dropdown">
            <button
                class="btn btn-primary"
                type="button"
                @click="showModal">
                Run Connection
            </button>
        </div>
        <div class="modal fade run-connection-modal" id="run-connection-modal" role="dialog" aria-hidden="true">
            <div class="modal-dialog task-form" role="document">
                <div class="modal-content">
                    <div class="modal-body align-content-center">
                        <fieldset class="form-group tasks-started">
                            <legend class="close-modal">
                                <strong>Run Connection</strong>
                                <div class="justify-content-end">
                                    <button class="btn close close-modal" data-dismiss="modal">
                                        <ion-icon name="close"></ion-icon>
                                    </button>
                                </div>
                            </legend>
                        </fieldset>
                        <div class="row">
                            <div class="col-6">
                                <app-select
                                    label="Connection"
                                    :error="connectionError"
                                    placeholder="Connection"
                                    name="connection_id"
                                    id="filter-type"
                                    :is-multiple="false"
                                    :use-search="false"
                                    :options="connections"
                                    @input="selectConnection"
                                ></app-select>
                            </div>
                            <div class="col-6">
                                <date-picker
                                    :disabled="true"
                                    id="processing_start_time"
                                    label="Processing start time"
                                    name="processing_start_time"
                                    placeholder="Processing start time"
                                    :config="config()"
                                    :value="todayValue"
                                ></date-picker>
                            </div>
                        </div>
                        <div class="modal-footer clearfix d-flex justify-content-end mt-2">
                            <button class="btn btn-danger mt-2" @click="runProcessing(selectedConnection.id)">
                                <ion-icon name="play" class="mb--1"></ion-icon> Run
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from "axios";

    export default {
        props: {
            connections: {
                type: Array,
                default: []
            },
            todayValue: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                selectedConnection: {},
                connectionError: ''
            }
        },
        methods: {
            showModal() {
                $('#run-connection-modal').modal('show');
            },
            selectConnection(connection_id) {
                this.selectedConnection = this.connections.find((con) => {
                    if (con.id == connection_id) {
                        return true;
                    }
                });
            },
            config() {
                return {
                    enableTime: true,
                    altFormat: 'm/j/Y H:i',
                    dateFormat: 'Y-m-d H:i',
                };
            },
            runProcessing(connection_id) {
                if (connection_id !== undefined) {
                    return axios.get(this.route('start-processing', connection_id))
                        .then(() => {
                            document.location.href = this.route('jobs-progress.index');
                        })
                } else {
                    this.connectionError = 'Connection is required';
                }
            },
        }
    }

</script>

<style scoped lang="scss">
button.btn-primary {
    color: #fff;
    background-color: #0060D6;
    font-weight: 500;
}

button.btn-primary:hover {
    color: #fff;
    background-color: #0060D6;
    font-weight: 500;
}
div.run-connection-modal {
    button.btn.close.close-modal {
        top: -40px;
        position: relative;
    }

    legend.close-modal {
        max-height: 25px;
    }

    .modal-footer {
        padding: 0;
    }

    .modal-footer > * {
        margin: 0;
    }
}
</style>
